import { render, staticRenderFns } from "./BrokerRisk.vue?vue&type=template&id=12734758&scoped=true"
import script from "./BrokerRisk.vue?vue&type=script&lang=js"
export * from "./BrokerRisk.vue?vue&type=script&lang=js"
import style0 from "./BrokerRisk.vue?vue&type=style&index=0&id=12734758&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12734758",
  null
  
)

export default component.exports